import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextEditorWithTitle from "./components/TextEditorWithTitle";
import { Button } from "@mui/material";
import { set } from "lodash";
import { createReviw, updateReview } from "../../services/subjects/unlimitedQuestionReview";
import Grid2 from "@mui/material/Unstable_Grid2";

function QuestionExplanationEditScreen() {
  const { explanationId = -1 } = useParams();
  const {questionId} = useParams()

  const [explanationData, setExplanationData] = useState({})
  const [loading, setLoading] = useState(false)
  const [explanation, setExplanation] = useState({})
  const [questionEditorState, setQuestionEditorState] = useState({})

  const navigate = useNavigate();

  useEffect(() => {
    if (explanationId > 0) {
      loadQuestionExplanation(explanationId);
    }
  }, [explanationId]);

  const loadQuestionExplanation = async (explanationId) => {
    const data = localStorage.getItem("questionReview");
    setExplanationData(JSON.parse(data) || {});
    // console.log(data)
  };

  


    const onsubmit = async () => {
      if (loading) return;
      if (explanationId > 0) {
        updateExistingExplanation();
      } else {
        saveNewExplanation();
      }
    };

    const saveNewExplanation = async () => {
      const newExplanation = {
        questionReview: explanation,
        questionReviewEditorState: questionEditorState,
        question: {
          id: questionId,
        },
      };

      try {
        const { data, status } = await createReviw(newExplanation);
        if (status === 200) {
          navigate(-1);
        }
      } catch (err) {
      } finally {
      }
    };

    const updateExistingExplanation = async () => {
      try {
        setLoading(true);
        const updatedExplanation = {
          editedQuestionReview: explanation,
          editedQuestionReviewEditorState: questionEditorState,
        };
        const { data, status } = await updateReview(
          explanationId,
          updatedExplanation
        );
        if (status === 200) {
          navigate(-1);
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    const {questionReview, questionReviewEditorState} = explanationData

  return (
    <Grid2 container>
      <TextEditorWithTitle
        title={"Question Explanation"}
        setLoading={setLoading}
        loading={loading}
        editorState={questionReviewEditorState}
        html={questionReviewEditorState ? null : questionReview}
        onChangeEditorState={setQuestionEditorState}
        onChangeHtml={setExplanation}
        currentHtml={explanation}
        // key={index}
      />
      <Button variant="contained" color="primary" onClick={onsubmit}>
        Save Explanation
        </Button> 
    </Grid2>
  );
}

export default QuestionExplanationEditScreen;
